export default __webpack_public_path__ + "static/media/circleGreen.f33b55bc.svg";